<sl-form-view [mainPageActions]="currentActions">
    @if (!!recordSummary() && !isLoadingResources()) {
        <mat-card>
            <mat-card-content class="container ml-0">
                <div class="row">
                    <div class="col-xl-4 col-lg-6 col-md-12 mb-3">
                        <h2 class="summary">{{ 'User.User' | translate }}</h2>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'User.Username' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.username }}</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Login.Role' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ roleName }}</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'User.ApprovalRight' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.approvalRight ? ('General.Yes' | translate) : ('General.No' | translate) }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-12 mb-3">
                        <h2 class="summary">{{ 'User.Contact' | translate }}</h2>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Contact.FirstName' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.firstName ? recordSummary()!.firstName : '-' }}</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Contact.LastName' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.lastName }}</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Contact.Email' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.email }}</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'User.PhoneNumber' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.phone }}</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Contact.MobileNumber' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.mobilePhoneNumber }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-12 mb-3">
                        <h2 class="summary">{{ 'General.OtherInformation' | translate }}</h2>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'General.Language' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ languageName }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'Shareholders.EmployeeNumber' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.employeeNumber ? recordSummary()!.employeeNumber : '-' }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'User.Function' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.function }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'User.WindowsUser' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.windowsUser }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="font-weight-light">{{ 'User.GetsNotified' | translate }}</label>
                            </div>
                            <div class="col-md-8">
                                <span>{{ recordSummary()!.getsNotified ? ('General.Yes' | translate) : ('General.No' | translate) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    }
</sl-form-view>
